<template>
<main>
<v-container class="grey lighten-4 fill-height">
  <v-row>
            <v-col class="mx-auto" >
              <v-card class="elevation-12 ma-3">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Deltagare</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
  <v-data-table
    :headers="getHeaders()"
    :items="participants"
    :items-per-page="10"
    no-data-text="Ingen data tillgänglig"
    :footer-props="{
    'items-per-page-text': 'Rader per sida:',
    'items-per-page-all-text': 'Allt',
    }"
    class="elevation-1"
  >
    <template v-slot:item.email="{ item }">
      {{ item.email === 'null'?'':item.email }}
    </template>
    <template v-slot:item.email_send_at="{ item }">
      {{ item.email_status === 1? 'E-post skickad kl ' + item.email_send_at:'' }}
    </template>
    <template v-slot:item.phone="{ item }">
      {{ item.phone === 'null'?'':item.phone }}
    </template>
  <!-- <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>{{ item.status === 'yes'?'öppna':'stängd' }}</v-chip>
    </template>
    <template v-slot:item.reply_deadline_date="{ item }">
      {{ item.reply_deadline === 'yes'?toDDMMYY(item.reply_deadline_date):'Ingen tidsfrist' }}
    </template> -->
    <template v-slot:footer.page-text="items">
       {{ items.pageStart }} - {{ items.pageStop }} av {{ items.itemsLength }} 
       </template>
  </v-data-table>

                       <h2 class="mt-5">Maila alla mottagare</h2>
<v-row>
 
                    <v-col cols="12" md="6">
                        <v-select
                            :items="admindates"
                            label="Valt datum"
                            outlined
                            item-text="name"
                            item-value="name"
                            v-model="finaldate"
                            dense
                        ></v-select>
                        <v-alert v-model="alertm" type="error" dismissible>
                            {{ alertmsgm }}
                        </v-alert>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-btn
                            style="background-color:#ffa500;"
                            @click="submitMail"
                            >Maila alla mottagare
                            <v-icon style="font-size:15px">
                                fas fa-check</v-icon
                            ></v-btn
                        >
                       <div class="caption"> Du mailar alla som angett sin mail-adress.</div>
                    </v-col>
                </v-row>
                <v-alert type="success" v-show="alerts" dismissible>
                    E-post har skickats.
                </v-alert>
 </v-card-text>
            </v-card>
            </v-col>
        </v-row>

  </v-container>
  </main>
</template>


<script>
import store from "../../../store";
import axios from "axios";
  export default {
    data () {
      return {
        store: store,
        id: this.$route.params.id,
        headers: [
          {
            text: 'Name',
            align: 'start',
            sortable: false,
            value: 'name',
            // v-if:participants.contact_info3 !== null,
          },
          { text: 'Email', value: 'email' },
          { text: 'Phone', value: 'phone' },
          this.p
        ],
        participants: [],
        admindates: [],
        dates: [],
            month: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "Maj",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dec"
            ],
        p: '',
        alertmsgm: '',
        finaldate: "",
        alerts: false,
        alertm: false,
      }
    },
    created: async function() {
      if (!this.store.state.isLoggedIn) this.$router.replace("/login");
        var config = {
            method: "get",
            url: `${this.store.state.baseURL}participants/${this.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.participants = resp.data.participants;
        this.p = `text:${this.participants[0].contact_info1}, value:"ci0"`
        this.getschedule()
    },
    methods: {
      getColor (status) {
        if (status === 'yes') return 'green'
        else return 'red'
      },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        getHeaders(){
          let info1 = this.participants[0].contact_info1=== null?'':this.participants[0].contact_info1
          let info2 = this.participants[0].contact_info2=== null?'':this.participants[0].contact_info2
          let info3 = this.participants[0].contact_info3=== null?'':this.participants[0].contact_info3
          let info4 = this.participants[0].contact_info4=== null?'':this.participants[0].contact_info4
          let info5 = this.participants[0].contact_info5=== null?'':this.participants[0].contact_info5
        let head = [
        {
            text: 'Name',
            align: 'start',
            sortable: false,
            value: 'name',
            // v-if:participants.contact_info3 !== null,
          },
          { text: 'Email', value: 'email' },
          { text: 'E-poststatus', value: 'email_send_at' },
          { text: 'Phone', value: 'phone' },
          {text: `${info1}`, value:"ci0"},
          {text: `${info2}`, value:"ci1"},
          {text: `${info3}`, value:"ci2"},
          {text: `${info4}`, value:"ci3"},
          {text: `${info5}`, value:"ci4"}
      ];
      // console.log(aa)
      return head
    },
    async getschedule () {
      var config = {
            method: "get",
            url: `${this.store.state.baseURL}showschedule/${this.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        // this.schedule = resp.data.schedule;
        this.dates = resp.data.time
        for (let i = 0; i < this.dates.length; i++) {
            let na = '';
            if(this.dates[i].time_from == '00:00:00'){
                na = this.toDDMMMYY(this.dates[i].schedule_date)
            }else if(this.dates[i].time_to == '00:00:00'){
                na = this.toDDMMMYY(this.dates[i].schedule_date) +
                    " " +
                    this.toMMHH(this.dates[i].time_from)
            }else{
                na = this.toDDMMMYY(this.dates[i].schedule_date) +
                    " " +
                    this.toMMHH(this.dates[i].time_from) +
                    " - " +
                    this.toMMHH(this.dates[i].time_to)
            }
            this.admindates.push({
                id: this.dates[i].id,
                name: na
            });
        }
    },
        toDDMMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()} ${
                this.month[dated.getMonth()]
            } ${dated.getFullYear()}`;
        },
        toMMHH(time) {
            return time.substring(0, 5);
        },
        async submitMail() {
            let bodyFormData = new FormData();
            bodyFormData.set("user_id", this.store.state.user.id);
            bodyFormData.set("schedule_id", this.id);
            bodyFormData.set("date", this.finaldate);
            const config = {
                method: "post",
                url: `${this.store.state.baseURL}mailrecepients`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };

            if (this.finaldate !== "") {
                await axios(config).then(resp => {
                    this.alerts = true;
                    console.log(resp);
                    // this.mailparticipants = resp.data.participants;
                });
            } else {
                this.alertmsgm = "Välj ett datum";
                this.alertm = true;
                return;
            }
        },
    },
  }
</script>